import type { Directory } from '~/modules/directory/type';
import { BANNER_DIMENSIONS } from '~/modules/page-builder/config/column-constants';

type ItemType = Extract<Directory, 'project' | 'article'>;

interface Dimension {
    width: number;
    height: number;
}

const DIMENSION_MAP_MOBILE: Record<ItemType, Dimension> = {
    article: {
        width: 414,
        height: 336,
    },
    project: {
        width: 414,
        height: 378,
    },
};

export const getBannerDimensions = (itemType: ItemType) => {
    const mobileDimension = DIMENSION_MAP_MOBILE[itemType];

    return {
        ...BANNER_DIMENSIONS,
        mobileWidth: mobileDimension.width,
        mobileHeight: mobileDimension.height,
    };
};
